import axios, { AxiosError } from 'axios'
import { useAppDispatch } from '../../store'
import { ApiResult } from '../../models/Enums'
import { useNavigate } from 'react-router'

export const axiosGet = async (api: string): Promise<any> => {
  try {
    const accessToken = sessionStorage.getItem('accessToken')
    const response = await axios.get(process.env.REACT_APP_API_SERVER + api, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    })
    return response.data
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.response?.status === 401) {
        const refreshToken = sessionStorage.getItem('refreshToken')

        const response = await axios.post(
          `${process.env.REACT_APP_API_SERVER}/api/auth/refresh`,
          { refreshToken }
        )

        // 로그인 오류
        if (response.data.result !== ApiResult.SUCCESS) {
          console.log('refresh token fail')
          const navigate = useNavigate()
          navigate('/login')
          return ''
        }

        if (response.data.accessToken === '') {
          console.log('refresh token fail')

          const navigate = useNavigate()
          navigate('/login')
          return ''
        }

        sessionStorage.setItem('accessToken', response.data.accessToken)
        sessionStorage.setItem('refreshToken', response.data.refreshToken)

        return await axiosGet(api)
      }
    }
    return ''
  }
}

export const axiosPost = async (
  api: string,
  data?: any,
  isMultiPart = false
): Promise<any> => {
  try {
    const accessToken = sessionStorage.getItem('accessToken')

    const headers = isMultiPart
      ? {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${accessToken}`,
        }
      : {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        }

    const response = await axios.post(
      process.env.REACT_APP_API_SERVER + api,
      data,
      { headers }
    )

    return response.data
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.response?.status === 401) {
        const refreshToken = sessionStorage.getItem('refreshToken')

        const response = await axios.post(
          `${process.env.REACT_APP_API_SERVER}/api/auth/refresh`,
          { refreshToken }
        )

        // 로그인 오류
        if (response.data.result !== ApiResult.SUCCESS) {
          console.log('refresh token fail')
          const navigate = useNavigate()
          navigate('/login')
          return ''
        }

        if (response.data.accessToken === '') {
          console.log('refresh token fail')
          const navigate = useNavigate()
          navigate('/login')
          return ''
        }

        sessionStorage.setItem('accessToken', response.data.accessToken)
        sessionStorage.setItem('refreshToken', response.data.refreshToken)

        return await axiosPost(api, data)
      }
    }
    return ''
  }
}

export const axiosPostWithRefreshToken = async (api: string, data?: any) => {
  try {
    const token = sessionStorage.getItem('accessToken')
    const response = await axios.post(
      process.env.REACT_APP_API_SERVER + api,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )

    return response.data
  } catch (error) {}
}
